<template>
  <div class="ai-feature-layout">
    <div class="ai-feature-layout__left-block">
      <img class="animated infinite ai-feature-layout__image" :src="imgSrc" />
    </div>
    <div class="ai-feature-layout__right-block">
      <h3 v-if="title">{{ title }}</h3>

      <slot />

      <div class="ai-feature-layout__disclaimer">
        この機能は
        <span style="color: var(--color-warn)">プレビュー版</span>
        です。ご利用にあたって、以下の点にご留意ください。
        <ul>
          <li>
            一部AIにより生成されたものであり、必ずしも正確・適切であるとは限りません。
          </li>
          <li>
            本機能の内容について、当社はその正確性・有用性を保証するものではありません。
          </li>
          <li>予告なく機能の変更・提供終了を行う場合があります。</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import imgSrc from '@/assets/images/character/pointing.png'

export default {
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      imgSrc,
    }
  },
}
</script>

<style lang="scss" scoped>
.ai-feature-layout {
  display: flex;

  &__left-block {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  &__image {
    position: sticky;
    top: var(--spacing-medium);

    width: 200px;
    transform: rotateY(180deg);
  }

  &__disclaimer {
    margin-top: var(--spacing-large);

    padding-left: var(--spacing-medium);
    padding-top: var(--spacing-small);
    padding-bottom: var(--spacing-small);

    border-left: 5px solid var(--color-border);

    font-size: var(--font-size-small);

    ul {
      padding-left: 20px;
    }
  }
}
</style>
